export default "__VITE_ASSET__ykRWGpaA__"